export default __webpack_public_path__ + "static/media/christmasCat.6e6b6481.png";